var codeblock_default = {
  "blockStyleSpacing": "MeUte",
  "codeBlock": "ih48R MeUte",
  "renderedInTable": "E03LA"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
